import { render, staticRenderFns } from "./splash.vue?vue&type=template&id=9ca722ae&"
import script from "./splash.vue?vue&type=script&lang=js&"
export * from "./splash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "splash.vue"
export default component.exports